import React, { useMemo, useState } from 'react';
import { Search } from 'lucide-react';

export default function UsersTab({ users }) {
  const [filter, setFilter] = useState('');
  const filtered = useMemo(() => {
    const f = filter.toLowerCase();
    return (users || []).filter(u => !f || (u.user_email || '').toLowerCase().includes(f));
  }, [users, filter]);
  const inactive = filtered.filter(u => u.inactive || u.events === 0).length;

  return (
    <div className="space-y-4" data-testid="governance-users">
      <div className="flex items-center gap-3">
        <div className="relative flex-1 max-w-sm">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            data-testid="user-filter-input"
            placeholder="Filter by email…"
            value={filter}
            onChange={e => setFilter(e.target.value)}
            className="w-full pl-9 pr-3 py-2 text-sm rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900"
          />
        </div>
        <div className="text-xs text-slate-500">{filtered.length} users · {inactive} inactive</div>
      </div>
      <div className="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900/50 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 dark:bg-slate-900 text-xs uppercase text-slate-500">
            <tr>
              <th className="px-4 py-2 text-left">User</th>
              <th className="px-4 py-2 text-right">Events (30d)</th>
              <th className="px-4 py-2 text-right">Distinct actions</th>
              <th className="px-4 py-2 text-right">Last active</th>
              <th className="px-4 py-2 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((u, i) => (
              <tr key={u.user_id || i} className="border-t border-slate-100 dark:border-slate-800">
                <td className="px-4 py-2 text-slate-700 dark:text-slate-300">{u.user_email || u.user_id || '—'}</td>
                <td className="px-4 py-2 text-right tabular-nums">{u.events || 0}</td>
                <td className="px-4 py-2 text-right tabular-nums">{u.distinct_event_types || 0}</td>
                <td className="px-4 py-2 text-right text-slate-500">{u.last_active ? new Date(u.last_active).toLocaleDateString() : '—'}</td>
                <td className="px-4 py-2">
                  {u.inactive || u.events === 0 ? (
                    <span className="text-xs px-2 py-0.5 rounded bg-slate-100 dark:bg-slate-800 text-slate-500">Inactive</span>
                  ) : (
                    <span className="text-xs px-2 py-0.5 rounded bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400">Active</span>
                  )}
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-8 text-center text-slate-400">No users match.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
